import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CookieService } from "ngx-cookie-service";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  NavigationExtras
} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserAuthenticationService {

  constructor(private router: Router, public cookieService: CookieService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // load sessionContext from session storage
    
    if(!environment.isSingleSignOn){
      return true;
    }

    if(environment.showDashboard && route.routeConfig.path !== 'profile' && route.routeConfig.path !== '/logout'){
      this.router.navigateByUrl('/dashboard');
      return true;
    }
    
    let isAuthenticated = this.cookieService.get('authToken');
    
    if(isAuthenticated) {
        // user.token = user.token.substring(0, 10) + '...';
        if(localStorage.getItem('userName') == '' || localStorage.getItem('isLoggedIn') == '' ) {
            this.router.navigate(['/']);          
            window.location.href = '/';
            return false;
        }
        return true;
    } else {        
        window.location.href = '/';
        return false;
    }
  }
}
